<template>
	<span>
		<v-text-field
			:hint="hint"
			persistent-hint
			v-model="fileName"
			:disabled="inputDisabled"
			@click="pickFile"
			prepend-icon="attach_file"
			:label="label"
			:rules="computedRules"
		></v-text-field>
		<input type="file" ref="file" style="display: none" @change="onFile($event)" :accept="accept" />
	</span>
</template>

<script>
import BaseInput from './baseInput'
export default {
	extends: BaseInput,
	props: {
		accept: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			privFileName: '',
		}
	},
	computed: {
		fileName: {
			get() {
				return this.model ? this.model.name : this.privFileName
			},
			set(val) {
				this.empty()
			},
		},
	},
	methods: {
		pickFile() {
			if (!this.inputDisabled) {
				this.$refs.file.click()
			}
		},
		empty() {
			this.model = null
			this.privFileName = null
			this.update()
		},
		onFile(event) {
			this.model = event.target.files[0]
			this.privFileName = event.target.files[0].name
			this.update()
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/baseComponents/inputs/fileInput.vue